import { Component } from "../../core/Component";
import moment from "moment";
export class DateComponent extends Component {
  constructor($root, options) {
    super($root, options);
    const {
      messages,
      useDesign = true
    } = options;

    // Основные параметры
    this.messages = messages;
    this.fieldId = options.id;
    this.typeId = options.typeId;
    this.label = options.label || "";
    this.hint = options.hint || "";
    this.type = options.type || "text";
    this.require = options.required === 1;
    this.placeholder = options.placeholder || " ";
    this.classes = options.classes || "";
    this.useDesign = useDesign;
    this.saveInStorage = options.data?.saveInStorage;
    this.formId = options.formId;

    // Генерация уникальных ID
    const timestamp = Date.now();
    this.name = options.name;
    this.id = `${this.name}_${options.formIndex}_${timestamp}`;
    this.datepickerId = `${this.name}_${options.formIndex}_datepicker_${timestamp}`;
    this.boxId = `${this.name}_${options.formIndex}_box_${timestamp}`;
    this.boxIdField = `${this.name}_${options.formIndex}_box-field_${timestamp}`;
    this.errorBox = `${this.name}_${options.formIndex}_error-box_${timestamp}`;
    this.errorBoxText = `${this.name}_${options.formIndex}_error-box_text_${timestamp}`;
    this.labelId = `${this.name}_${options.formIndex}_label_${timestamp}`;

    // Диапазон дат
    this.min = this.parseDate(options.min);
    this.max = this.parseDate(options.max);

    // Классы оформления
    this.wrapClasses = this.makeWrapUserClasses();

    // Пикер (ленивая загрузка)
    this.Datepicker = null;

    // DOM-элементы (инициализируются в init)
    this.$input = null;
    this.$box = null;
    this.$boxField = null;
    this.$errorBox = null;
    this.$errorBoxText = null;
  }

  /**
   * Парсит строку в Date и устанавливает время (начало/конец дня)
   * @param {string | number | Date | null} date
   * @returns {Date | null}
   */
  parseDate(date) {
    if (!date) return null;
    const parsed = new Date(date);
    if (isNaN(parsed.getTime())) return null;
    // min: начало дня, max: конец дня
    return date === this.options.max ? this.setEndOfDay(parsed) : this.setStartOfDay(parsed);
  }
  setStartOfDay(date) {
    date.setHours(0, 0, 0, 0);
    return date;
  }
  setEndOfDay(date) {
    date.setHours(23, 59, 59, 999);
    return date;
  }

  /**
   * Форматирует дату в строку ДД.ММ.ГГГГ
   * @param {Date} date
   * @returns {string}
   */
  formatDate(date) {
    return moment(date).format('dd.MM.YYYY');
  }
  toHTML() {
    const {
      min,
      max,
      require,
      useDesign,
      label,
      placeholder,
      classes,
      hint,
      wrapClasses
    } = this;
    const minAttr = min ? `data-min="${moment(min).format("DD.MM.YYYY")}"` : "";
    const maxAttr = max ? `data-max="${moment(max).format("DD.MM.YYYY")}"` : "";
    return `
      <div class="qform-field datepickers qform_icon-date ${hint ? "qform-hint" : ""} ${wrapClasses?.join(" ")}" id="${this.boxId}">
        <div class="qform-field_wrap">
          ${this.toHtmlOutLabelBox()}
          <div class="qform-field__block">
            ${this.toHtmlAttBox("out_left")}
            <div class="qform-field__block_box">
              <div class="qform-field__block_box__field" id="${this.boxIdField}">
                ${this.toHtmlAttBox("in_left")}
                <div class="qform-field__block_box__field-box">
                  <input
                    type="date"
                    class="qform-field__block_box__field-box_input datepicker-here ${classes}"
                    ${minAttr}
                    ${maxAttr}
                    maxlength="10"
                    data-active="0"
                    data-class_show=""
                    name="${this.name}"
                    id="${this.id}"
                    placeholder="${placeholder}"
                    ${require ? "required" : ""}
                  >
                  ${useDesign ? this.renderLabel() : ""}
                </div>
                ${this.toHtmlAttBox("in_right")}
              </div>
            </div>
            ${this.toHtmlAttBox("out_right")}
          </div>
        </div>
        ${this.toHtmlBottomBox()}
      </div>
    `;
  }

  /**
   * Рендер label с пометкой о необходимости
   * @returns {string}
   */
  renderLabel() {
    const unrequiredLabel = this.options.messages?.unrequired || "необязательное";
    return `
      <label for="${this.id}" class="qform-field__block_box__field-box_label">
        ${this.label}
        <span class="qform-field__importance-label">(${unrequiredLabel})</span>
      </label>
    `;
  }
  init() {
    let {
      disable = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.$input = this.$root.$el.querySelector(`#${this.id}`);
    this.$box = this.$root.$el.querySelector(`#${this.boxId}`);
    this.$boxField = this.$root.$el.querySelector(`#${this.boxIdField}`);
    this.$errorBox = this.$root.$el.querySelector(`#${this.errorBox}`);
    this.$errorBoxText = this.$root.$el.querySelector(`#${this.errorBoxText}`);
    if (!disable) {
      this.listeners = [{
        eventName: "change",
        method: "onChange",
        el: this.$input
      }, {
        eventName: "focus",
        method: "onFocus",
        el: this.$input
      }, {
        eventName: "blur",
        method: "onBlur",
        el: this.$input
      }, {
        eventName: "keydown",
        method: "onKeyDown",
        el: this.$input
      }, {
        eventName: "input",
        method: "onInput",
        el: this.$input
      }, {
        eventName: "paste",
        method: "onPaste",
        el: this.$input
      }];
    }
    super.init();

    // Установка min/max для нативного input[type="date"]
    if (this.min) this.$input.min = moment(this.min).format("YYYY-MM-DD");
    if (this.max) this.$input.max = moment(this.max).format("YYYY-MM-DD");

    // Восстановление значения из localStorage
    if (this.saveInStorage) {
      const stored = JSON.parse(localStorage.getItem(this.formId)) || {};
      if (stored[this.name]) {
        this.$input.value = stored[this.name];
      }
    }
  }
  onChange() {
    this.$emit("Change:field", {
      name: this.name,
      value: this.$input.value
    });
    if (this.saveInStorage) {
      const stored = JSON.parse(localStorage.getItem(this.formId)) || {};
      stored[this.name] = this.$input.value;
      localStorage.setItem(this.formId, JSON.stringify(stored));
    }
  }
  onFocus() {
    this.$boxField.classList.add("qform-field-focus");
  }
  onBlur() {
    this.$boxField.classList.remove("qform-field-focus");
    this.setMessageValid();
    this.validation();
  }
  onKeyDown() {}
  onInput() {}
  onPaste() {}
  getValue() {
    return {
      id: this.fieldId,
      name: this.name,
      typeId: this.typeId,
      values: this.$input.value ? [new Date(this.$input.value).getTime()] : []
    };
  }
  async getDatePicker() {
    if (this.Datepicker) return;
    const {
      DatePicker
    } = await import(/* webpackChunkName: "DatePickerComponent" */
    "./DatePicker.component");
    this.Datepicker = new DatePicker(this.$input, this.boxIdField, {
      messages: this.messages,
      use_default: this.options.useDefault
    });
    this.Datepicker.init();
  }
  async setClassField(data) {
    const {
      formStyleDate,
      formStyleFieldRequired
    } = data || {};

    // Стиль открытия календаря
    if (formStyleDate?.style === 1) {
      this.$input.dataset.class_show = "open";
    } else if (formStyleDate?.style === 2) {
      this.$input.dataset.class_show = "open-gap";
    }

    // Удаление классов оформления, если отключено
    if (!formStyleDate?.useDesign) {
      this.$root.$el.className = "";
    }

    // Обработка required стилей
    if (formStyleFieldRequired) {
      this.$box.classList.toggle("required", formStyleFieldRequired.type === 0 && this.require);
      this.$box.classList.toggle("not-required", formStyleFieldRequired.type === 1 && !this.require);
      if (!formStyleFieldRequired.useDesign) {
        this.$box.classList.remove("required", "not-required");
      }
    }

    // Инициализация пикера, если нужен
    if (formStyleDate?.style > 0 && !this.Datepicker) {
      this.$input.readOnly = true;
      await this.getDatePicker();
    }
  }
  validation() {
    let showError = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    let isValid = true;
    let message = "";
    if (this.require && !this.$input.value) {
      message = this.messages.inputRequired;
    } else if (this.$input.value) {
      const valueTime = new Date(this.$input.value).getTime();
      if (this.max && valueTime > this.max.getTime()) {
        message = this.messages.inputDateMax.replace("{0}", this.formatDate(this.max));
      } else if (this.min && valueTime < this.min.getTime()) {
        message = this.messages.inputDateMin.replace("{0}", this.formatDate(this.min));
      }
    }
    if (message && showError) {
      this.setMessageValid(message);
      isValid = false;
    } else {
      this.setMessageValid();
      this.setSuccessValid(!!this.$input.value);
    }
    return isValid;
  }
}